import { createGlobalStyle } from "styled-components";
import theme from "./theme";

const GlobalStyle = createGlobalStyle`
  html {
		min-height: 100%;
		font-family: ${theme.fonts.base};
		font-size: 62.5%;
		line-height: normal;
		-webkit-font-smoothing: antialiased;
  }

  body {
  	    margin: 0;
		background: ${theme.colors.bgGlobal};
		color: ${theme.colors.white1};
        font-size: ${theme.fontSizes[2]};
  }

	.ism {
		box-sizing: border-box;
		font-family: ${theme.fonts.base};

		*, *::before, *::after {
			box-sizing: inherit;
		}

		p {
			line-height: 1.6;
			font-size: 14px;
		}

		input[type="search"] {
			box-sizing: inherit;
		}
		
  }
	a  {
			color: ${theme.colors.white1};
  }
`;

export default GlobalStyle;
